import React from "react";

import Link from "./Link";
import UserActionArea from "./UserActionArea";
import { MenuItem, Menu } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import classNames from "classnames";
import styles from "./BottomNav.module.css";

/** Single dropdown nav item with its own open/anchor state so menus don't share state. */
const DropdownNavItem = ({ link, hasExternalUrls }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <li className={"m-site-nav-inline--primary__item pointer"}>
      <a
        data-testid={`t-Dropdown-Button t-Dropdown-Button-${link.id}`}
        aria-controls={open ? `basic-menu-${link.id}` : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className={classNames("primary-color-text", styles.dropdownButtonWrapper)}>
        {link.text} <KeyboardArrowDownIcon />
      </a>
      <Menu
        id={`basic-menu-${link.id}`}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        autoFocus={false}>
        {link.dropdown_links.map((dropDownLink) => (
          <MenuItem
            key={dropDownLink.id}
            component={Link}
            onClick={handleClose}
            className={hasExternalUrls ? "primary-color-text" : ""}
            {...dropDownLink}>
            {dropDownLink.text}
          </MenuItem>
        ))}
      </Menu>
    </li>
  );
};

export const RenderLinks = ({ links, hasExternalUrls }) => {
  const linkComponents = links.map((link) => {
    if (link.drop_down && link.dropdown_links) {
      return (
        <DropdownNavItem key={link.id} link={link} hasExternalUrls={hasExternalUrls} />
      );
    } else {
      return (
        <li key={link.id} className="m-site-nav-inline--primary__item">
          <Link className={hasExternalUrls ? "primary-color-text" : ""} {...link} />
        </li>
      );
    }
  });
  return (
    <ul
      className={
        hasExternalUrls
          ? "m-site-nav-inline--primary"
          : "m-site-nav-inline--primary-simple"
      }>
      {linkComponents}
    </ul>
  );
};

export function BottomNav(props) {
  const { links, user, hasExternalUrls, entity, menu, assets, campaign } = props;

  return (
    <div
      id="main-nav"
      className={`m-site-simple-nav${
        hasExternalUrls ? "" : " nav-sticky primary-color-background"
      }`}>
      <nav className="container full-h flex-center-all">
        <RenderLinks links={links} hasExternalUrls={hasExternalUrls} />
        <UserActionArea
          user={user}
          entity={entity}
          menu={menu}
          assets={assets}
          campaign={campaign}
          hasExternalUrls={hasExternalUrls}
        />
      </nav>
    </div>
  );
}

export default BottomNav;
